import React from "react";
import Moment from "react-moment";
import { FORMAT_TIME, STATUS_EXCUTED } from "../../../../api/constant";
import {
  useActionsEntry,
  useDispatchEntryForm,
  useEntry,
} from "../../../../context/inventory/EntryFormProvider";
import FileUpload from "../../../app/atoms/FileUpload";
import IconFile from "../../../app/atoms/IconFile";
import "./document.css";
const Document = () => {
  const state = useEntry();
  const dispatch = useDispatchEntryForm();
  const actions = useActionsEntry();
  const {
    entry: { document },
  } = state;
  const { documents } = document;
  const { status_id } = state.entry;

  const handleChange = (files) => {
    actions.addDocumentsToEntry(files);
  };
  const fileTypes = ["JPEG", "PNG", "PDF", "XLSX", "DOC"];
  return (
    <section className="container-fluid">
      <div className="flex">
        {status_id !== STATUS_EXCUTED && (
          <div className="container-fluid flex-column">
            <div className="flex justify-betwen">
              <label className="font1">
                Suba archivos (imágenes, videos, pdf, excel y word)
              </label>
            </div>
            <div className="container-drop-file-entry">
              <FileUpload handleChange={handleChange} fileTypes={fileTypes} />
            </div>
          </div>
        )}

        <div className="flex0 container-fluid">
          <table className="table table-default-app">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Modificado por</th>
                <th className="d-none d-xl-block">Última modificación</th>
              </tr>
            </thead>
            <tbody>
              {documents.map((doc) => {
                return (
                  <tr key={doc.id}>
                    <td>
                      <IconFile type={doc.type} /> {doc.title}{" "}
                    </td>
                    <td>{doc.user_name}</td>
                    <td className="d-none d-xl-block">
                      <Moment format={FORMAT_TIME}>{doc.updated_at}</Moment>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Document;
